export default "__VITE_ASSET__BtM5rJjE__"